import { useEffect, useState } from "react";
import { Bell, BellRing, BellOff } from "lucide-react";
import { toast } from "sonner";
import { subscribePush, unsubscribePush, getPushState, pushSupported } from "../lib/push";

export function PushButton({ userType = "public", variant = "light" }) {
  const [state, setState] = useState("default");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    getPushState().then(setState);
  }, []);

  if (!pushSupported() || state === "unsupported") return null;

  const toggle = async () => {
    setBusy(true);
    try {
      if (state === "subscribed") {
        await unsubscribePush();
        setState("default");
        toast.success("Alerts turned off");
      } else {
        await subscribePush(userType);
        setState("subscribed");
        toast.success("Alerts on — you'll be notified of emergencies");
      }
    } catch (e) {
      toast.error(state === "denied" || Notification.permission === "denied"
        ? "Notifications are blocked in your browser settings."
        : "Could not enable alerts.");
    } finally {
      setBusy(false);
    }
  };

  const subscribed = state === "subscribed";
  const Icon = subscribed ? BellRing : state === "denied" ? BellOff : Bell;
  const base = "inline-flex items-center gap-1.5 text-sm font-semibold px-3 py-2 rounded-full transition-colors";
  const styles = variant === "dark"
    ? (subscribed ? "bg-alert text-ink" : "bg-white/10 text-white hover:bg-white/20")
    : (subscribed ? "bg-calm text-white" : "border border-line bg-white text-clinical hover:bg-line/40");

  return (
    <button onClick={toggle} disabled={busy} data-testid="push-toggle-btn" className={`${base} ${styles}`} title="Emergency alerts">
      <Icon className="w-4 h-4" />
      <span className="hidden sm:inline">{subscribed ? "Alerts on" : "Get alerts"}</span>
    </button>
  );
}
